import { Injectable } from '@angular/core';
import { debounceTime, share, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ScrollService {
	private scrollSubject = new Subject<void>();
	public scrollObserver = this.scrollSubject.pipe(
		debounceTime(100),
		share()
	);

	public scrollToElement(element: Element): void {
		if (element) {
			element.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
				inline: 'nearest',
			});
		}
	}

	public onScroll(): void {
		this.scrollSubject.next();
	}

}
